import { Arrow } from '@public';
import { WaterAccountType } from '@types';

import styles from './waterAccountItem.module.scss';

export interface WaterAccountItemProps {
	waterAccount: WaterAccountType;
	onItemClick: (waterAccount: WaterAccountType) => void;
	selected: boolean;
}

export const WaterAccountItem = ({
	waterAccount,
	onItemClick,
	selected,
}: WaterAccountItemProps) => {
	const {
		accountName,
		accountReference,
		managementGroup,
		managementSubGroup: managementSubgroup,
	} = waterAccount;
	return (
		<tr
			className={[styles.container, selected && styles['container-selected']].join(' ')}
			onClick={() => {
				onItemClick(waterAccount);
			}}
			role="row"
		>
			<td role="rowheader">{accountName}</td>
			<td>{accountReference}</td>
			<td>{managementGroup}</td>
			<td>{managementSubgroup}</td>
			<td>
				<button
					className={styles.arrow}
					aria-label={['Select ', { name }].join(' ')}
					tabIndex={0}
					onClick={() => {
						onItemClick(waterAccount);
					}}
				>
					<Arrow customStyles={styles.arrow} />
				</button>
			</td>
		</tr>
	);
};
